// Production release: 2026-03-04
import React, { useContext, useState } from "react";
import CouponContext from "./CouponContext";
import { getStoresByRetailer } from "../../API/Wholesalerapi";
import { Modal, Button, OverlayTrigger } from "react-bootstrap";
import { renderTooltip } from "../../Components/Helper";

const getStoreId = (store) => store.rsa_store_identifier;
const getStoreName = (store) => store.store_name || String(store.retailer_store_id);

const TargetList = ({ couponTargetTypeId, data, selectIds, brandguid }) => {
  const { couponData, updateCouponData } = useContext(CouponContext);
  const [modalRetailerId, setModalRetailerId] = useState(null);
  const [storesByRetailer, setStoresByRetailer] = useState({});
  const [storesLoading, setStoresLoading] = useState(false);
  const [storeSearch, setStoreSearch] = useState("");

  const openStoreModal = async (retailer_id) => {
    setStoreSearch("");
    setModalRetailerId(retailer_id);
    if (!storesByRetailer[retailer_id]) {
      setStoresLoading(true);
      try {
        const res = await getStoresByRetailer(retailer_id, brandguid);
        setStoresByRetailer(prev => ({
          ...prev,
          [retailer_id]: res?.data?.Message || []
        }));
      } catch {
        setStoresByRetailer(prev => ({ ...prev, [retailer_id]: [] }));
      }
      setStoresLoading(false);
    }
  };

  const updateStores = (retailer_id, store_id, checked) => {
    const updatedRetailers = couponData.retailers.map(r => {
      if (r.retailer_id !== retailer_id) return r;
      const current = r.store_specific || [];
      const updated = checked
        ? [...current, store_id]
        : current.filter(id => id !== store_id);
      return { ...r, store_specific: updated };
    });
    updateCouponData({ retailers: updatedRetailers });
  };

  const activeRetailerName = data.retailersData?.find(r => r.retailer_id === modalRetailerId)?.retailer_name || "";
  const activeStores = storesByRetailer[modalRetailerId] || [];
  const activeSelected = couponData.retailers?.find(r => r.retailer_id === modalRetailerId)?.store_specific || [];
  const filteredStores = storeSearch
    ? activeStores.filter(s => getStoreName(s).toLowerCase().includes(storeSearch.toLowerCase()))
    : activeStores;

  const renderListItems = () => {
    switch (couponTargetTypeId) {
      case 1:
        return data.wholesalersData.map((eachData) => (
          <li key={eachData.wholesaler_id}>
            <div className="Retailer_Block" style={{ boxShadow: "3px 3px 3px #B2BEB5" }}>
              <input
                type="checkbox"
                id="Retailer"
                disabled={couponData.action === "edit" || couponData.action === "view"}
                checked={couponData.selectedIds.includes(eachData.wholesaler_id)}
                onChange={(e) => selectIds(e.target.checked, eachData.wholesaler_id)}
              />
              <div className="RetailerImage">
                <img src={eachData.logo} className="img-fluid" alt={eachData.wholesaler_name} />
              </div>
              <h5>{eachData.wholesaler_name}</h5>
            </div>
          </li>
        ));
      case 2:
        return data.retailersData.map((eachData) => {
          const isChecked = couponData.selectedIds.includes(eachData.retailer_id);
          const selectedStoreCount = couponData.retailers?.find(r => r.retailer_id === eachData.retailer_id)?.store_specific?.length || 0;
          return (
            <li key={eachData.retailer_id}>
              <div className="Retailer_Block" style={{ boxShadow: "3px 3px 3px #B2BEB5" }}>
                <input
                  type="checkbox"
                  id="Retailer"
                  disabled={couponData.action === "edit" || couponData.action === "view"}
                  checked={isChecked}
                  onChange={(e) => selectIds(e.target.checked, eachData.retailer_id)}
                />
                <div className="RetailerImage">
                  <img src={eachData.logo} className="img-fluid" alt={eachData.retailer_name} />
                </div>
                <h5>{eachData.retailer_name}</h5>
                {isChecked && (couponData.action !== "view" || selectedStoreCount > 0) && (
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 200, hide: 300 }}
                    overlay={renderTooltip("Store specific targeting coming soon")}
                  >
                    <span style={{ display: "block", width: "100%", marginTop: "6px" }}>
                      <button
                        type="button"
                        onClick={() => {/* openStoreModal(eachData.retailer_id) — store-specific selection temporarily disabled */}}
                        style={{
                          fontSize: "11px",
                          padding: "2px 8px",
                          borderRadius: "12px",
                          border: selectedStoreCount > 0 ? "1px solid #3d8ecc" : "1px solid #ccc",
                          background: selectedStoreCount > 0 ? "#e8f3fb" : "#f5f5f5",
                          color: selectedStoreCount > 0 ? "#3d8ecc" : "#888",
                          cursor: "default",
                          display: "block",
                          width: "100%",
                        }}
                      >
                        {selectedStoreCount > 0 ? `${selectedStoreCount} store${selectedStoreCount !== 1 ? "s" : ""}` : "All stores"}
                      </button>
                    </span>
                  </OverlayTrigger>
                )}
              </div>
            </li>
          );
        });
      case 3:
        return data.retailerGroupData.map((retailerGroup) => (
          <li key={retailerGroup.retailer_group_id}>
            <div className="Retailer_Block" style={{ boxShadow: "3px 3px 3px #B2BEB5" }}>
              <input
                type="checkbox"
                id="Retailer"
                disabled={couponData.action === "edit" || couponData.action === "view"}
                checked={couponData.selectedIds.includes(retailerGroup.retailer_group_id)}
                onChange={(e) => selectIds(e.target.checked, retailerGroup.retailer_group_id)}
              />
              <h5>{retailerGroup.group_name}</h5>
            </div>
          </li>
        ));
      default:
        return null;
    }
  };

  return (
    <>
      <ul className="mt-30 d-flex Retailer">{renderListItems()}</ul>

      <Modal show={modalRetailerId !== null} onHide={() => setModalRetailerId(null)} centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "16px" }}>
            {activeRetailerName} — Specific Stores
            <div style={{ fontSize: "12px", fontWeight: 400, color: "#888", marginTop: "2px" }}>
              Optional — leave blank to target all stores
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "0" }}>
          {!storesLoading && activeStores.length > 0 && (
            <div style={{ padding: "10px 16px", borderBottom: "1px solid #f0f0f0" }}>
              <input
                type="text"
                placeholder="Search stores…"
                value={storeSearch}
                onChange={(e) => setStoreSearch(e.target.value)}
                style={{ width: "100%", padding: "6px 10px", border: "1px solid #ddd", borderRadius: "4px", fontSize: "13px", outline: "none" }}
              />
            </div>
          )}
          <div style={{ maxHeight: "360px", overflowY: "auto", padding: "0 16px" }}>
            {storesLoading ? (
              <div style={{ textAlign: "center", padding: "20px", color: "#aaa" }}>Loading stores…</div>
            ) : activeStores.length === 0 ? (
              <div style={{ textAlign: "center", padding: "20px", color: "#aaa" }}>No stores available</div>
            ) : filteredStores.length === 0 ? (
              <div style={{ textAlign: "center", padding: "20px", color: "#aaa" }}>No stores match your search</div>
            ) : (
              filteredStores.map(store => {
                const storeId = getStoreId(store);
                return (
                  <label
                    key={store.retailer_store_id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      padding: "6px 0",
                      borderBottom: "1px solid #f0f0f0",
                      cursor: couponData.action === "view" ? "default" : "pointer",
                      fontSize: "14px"
                    }}
                  >
                    <input
                      type="checkbox"
                      disabled={couponData.action === "view"}
                      checked={activeSelected.includes(storeId)}
                      onChange={(e) => updateStores(modalRetailerId, storeId, e.target.checked)}
                    />
                    {getStoreName(store)}
                  </label>
                );
              })
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          {couponData.action !== "view" && activeSelected.length > 0 && (
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => {
                const updatedRetailers = couponData.retailers.map(r =>
                  r.retailer_id === modalRetailerId ? { ...r, store_specific: [] } : r
                );
                updateCouponData({ retailers: updatedRetailers });
              }}
            >
              Clear All
            </Button>
          )}
          <Button variant="primary" size="sm" onClick={() => setModalRetailerId(null)}>
            Done
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TargetList;
